import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

const URL = environment.urlBackend;

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform( param: number): string {
    // tslint:disable-next-line:max-line-length
    // En el alemán la coma se utiliza como separador decimal y el punto para los millares -  el formato argentino coloca coma en donde va el punto (20,000)
    const formatNumber = (new Intl.NumberFormat('de-DE').format(param));
    return formatNumber;
  }

}
// console.log(new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number));
// const numberformat = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: '' }).format(param));
